import handlePowerRouteHandle from "@/views/power/routerHandle";
import { RouteRecordRaw } from "vue-router";

const powerRoutes: RouteRecordRaw[] = [
  {
    path: "/power",
    name: "power",
    meta: {
      auth: true,
      label: "会员中心",
      useTopbar: true,
      layout: "simple"
    },
    beforeEnter: handlePowerRouteHandle,
    component: () => import("@/views/power/index.vue")
  },
  {
    path: "/power/powerDetails",
    name: "powerDetails",
    meta: {
      auth: true,
      label: "算力明细",
      useTopbar: true,
      layout: "simple"
    },
    component: () => import("@/views/power/children/powerDetails.vue")
  },
  {
    path: "/power/order",
    name: "order",
    meta: {
      auth: true,
      label: "我的订单与发票",
      useTopbar: true,
      layout: "simple"
    },
    component: () => import("@/views/power/children/order.vue")
  },
  {
    path: "/power/subscription",
    name: "subscription",
    meta: {
      auth: true,
      label: "订阅计划",
      useTopbar: true,
      layout: "simple"
    },
    component: () => import("@/views/power/children/subscription/index.vue")
  }
];

export default powerRoutes;
